// src/pages/invoicing/Invoicing.js

import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import { Link } from "react-router-dom";
import "../../styles/custom.css";
import API_BASE_URL from "../../config";

const Invoicing = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    document.title = "Invoicing | Webyappy";

    fetch(`${API_BASE_URL}/auth/check_session`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "active") {
          setUser(data.user);
        }
      });
  }, []);

  const hasAccess = (key) =>
    user?.role === "Superadmin" || user?.assigned_microapps?.includes(key);

  return (
    <>
      <Header />
      <div style={{ paddingTop: "70px", paddingBottom: "70px" }}>
        <div className="container-fluid px-3 py-3">
          {/* Breadcrumb */}
          <div className="d-flex align-items-center justify-content-between mb-4">
            <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold mb-0 p-0">
              <li className="breadcrumb-item">
                <Link to="/home" className="text-muted">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item">
                <span className="text-muted">Invoicing</span>
              </li>
            </ul>
          </div>

          {/* Invoicing Cards */}
          <div className="row">
            {/* Proforma Invoice */}
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-5">
              <div className="card department-microapp-card shadow-sm h-100">
                <div className="card-body position-relative">
                  <h6 className="text-dark font-weight-bold mb-3">Proforma Invoice</h6>
                  <hr />
                  <ul className="list-unstyled mb-0">
                    {hasAccess("inv_create_pi") && (
                      <li className="mb-2">
                        <Link to="/pages/invoicing/create-pi" className="microapp-link">
                          Create Proforma
                        </Link>
                      </li>
                    )}
                    {hasAccess("inv_view_pi") && (
                      <li className="mb-2">
                        <Link to="/pages/invoicing/view-pi" className="microapp-link">
                          View Proforma
                        </Link>
                      </li>
                    )}
                    {hasAccess("inv_edit_pi") && (
                      <li className="mb-2">
                        <Link to="/pages/invoicing/edit-pi" className="microapp-link">
                          Edit Proforma
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>

            {/* Tax Invoice */}
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-5">
              <div className="card department-microapp-card shadow-sm h-100">
                <div className="card-body position-relative">
                  <h6 className="text-dark font-weight-bold mb-3">Tax Invoice</h6>
                  <hr />
                  <ul className="list-unstyled mb-0">
                    {hasAccess("inv_create_tax_standalone") && (
                      <li className="mb-2">
                        <Link to="/pages/invoicing/create-tax-standalone" className="microapp-link">
                          Standalone Tax Invoice
                        </Link>
                      </li>
                    )}
                    {hasAccess("inv_create_tax_from_pi") && (
                      <li className="mb-2">
                        <Link to="/pages/invoicing/create-tax-from-pi" className="microapp-link">
                          Tax Invoice Against PI
                        </Link>
                      </li>
                    )}
                    {hasAccess("inv_view_tax") && (
                      <li className="mb-2">
                        <Link to="/pages/invoicing/view-tax" className="microapp-link">
                          View/Edit Tax Invoice
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Invoicing;
